webpackJsonp([142629428675168],{

/***/ 443:
/***/ (function(module, exports) {

	module.exports = {"data":{"allContentfulHomepage":{"edges":[{"node":{"id":"c3abbrmiTS8aIQusE8gUequ","title":"Hey! I’m Rowan.","opener":"I'm a senior software engineer from Vancouver, Canada. I work at Spexi, a marketplace for geospatial data captured via drone.","action":{"id":"c3TVmhbbxlTRIZI2fDGE1Pc","text":"Visit spexi.com","url":"https://spexi.com/"},"posts":[{"id":"c7FTyLDdrFF52KDxogUoSQl","originalPublishDate":"2024-07-21","createdAt":"2024-07-22T01:12:18.789Z","slug":"slow-down","title":"Slow Down","emoji":"🐌","body":{"id":"c7FTyLDdrFF52KDxogUoSQlbodyTextNode","childMarkdownRemark":{"id":"c7FTyLDdrFF52KDxogUoSQlbodyTextNode >>> MarkdownRemark","html":"<p>I'm going to leave this post as a little reminder for myself in the future, when I remember to check if this website – my internet flag pole – is up.</p>\n<p>Let the leaves blow in the wind. Do not be blown away with them.</p>"}}}]}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-db59478866cacd7034e2.js